<template>
  <tr>
    <form-item-label label="経験年数" :required="true" />
    <complemented-text-form
      v-if="complementedTextOpened"
      :text="complementedText"
      @open="openForm"
      :editable="true"
      :colspan="3"
    />

    <td colspan="3" v-show="!complementedTextOpened">
      <div
        class="m3p-contact__input_group"
        v-for="(experience, idx) in experiencesAttributes"
        :key="idx"
      >
        <experience-position-type-form
          :selectiveExperiencePositionTypeList="
            selectiveExperiencePositionTypeList
          "
          :experiencePositionType="experience.position_type"
          @change="(name, value) => changeValue(idx, name, value)"
        />

        <experience-year-form
          :selectiveExperienceYearList="selectiveExperienceYearList"
          :experienceYear="experience.year"
          @change="(name, value) => changeValue(idx, name, value)"
        />
        <a
          v-if="
            numberOfExperiences < 3 && parseInt(idx) + 1 === numberOfExperiences
          "
          @click.prevent="increaseExperience"
          href="#"
          class="m3p-searchbox__btn"
          >履歴を追加</a
        >
        <a
          v-if="
            numberOfExperiences > 1 && parseInt(idx) + 1 === numberOfExperiences
          "
          @click.prevent="decreaseExperience"
          href="#"
          class="m3p-searchbox__btn_white"
          >経歴を削除</a
        >
      </div>
    </td>
  </tr>
</template>

<script setup>
import ComplementedTextForm from '@component_path/pages/pc/positions/show/common_components/form_element/ComplementedText';
import FormItemLabel from '@component_path/pages/pc/positions/show/common_components/form_element/FormItemLabel';
import ExperiencePositionTypeForm from '@component_path/pages/pc/positions/show/inquiry_form/components/inquiry_form_item/ExperiencePositionType';
import ExperienceYearForm from '@component_path/pages/pc/positions/show/inquiry_form/components/inquiry_form_item/ExperienceYear';
import { computed, onMounted, ref } from 'vue';

const emit = defineEmits(['change']);

const props = defineProps({
  positionTypeMaster: {
    type: Array,
    required: true
  },
  experienceYearMaster: {
    type: Array,
    required: true
  },
  experiencesAttributes: {
    type: Object,
    required: true
  }
});

const complementedTextOpened = ref(false);

const selectiveExperiencePositionTypeList = computed(() =>
  props.positionTypeMaster.map(positionType => ({
    code: positionType.code,
    name: positionType.name
  }))
);
const selectiveExperienceYearList = computed(() =>
  props.experienceYearMaster.map(experienceYear => ({
    code: experienceYear.value.toString(),
    name: experienceYear.text
  }))
);
const numberOfExperiences = computed(
  () => Object.keys(props.experiencesAttributes).length
);
const complementedText = computed(() =>
  Object.keys(props.experiencesAttributes).map(key => {
    const positionType = selectiveExperiencePositionTypeList.value.find(
      positionType =>
        positionType.code === props.experiencesAttributes[key].position_type
    ).name;
    const year = selectiveExperienceYearList.value.find(
      experienceYear =>
        experienceYear.code === props.experiencesAttributes[key].year
    ).name;
    return `${positionType} ${year}`;
  })
);

const addExperience = key => {
  const experiencesAttributes = Object.assign({}, props.experiencesAttributes);
  experiencesAttributes[key] = {
    position_type: 'PHARMACY',
    year: '0'
  };
  emit('change', 'experiences_attributes', experiencesAttributes);
};
const removeExperience = key => {
  const experiencesAttributes = Object.assign({}, props.experiencesAttributes);
  delete experiencesAttributes[key];
  emit('change', 'experiences_attributes', experiencesAttributes);
};
const changeValue = (key, name, newValue) => {
  const experiencesAttributes = Object.assign({}, props.experiencesAttributes);
  experiencesAttributes[key][name] = newValue;
  emit('change', 'experiences_attributes', experiencesAttributes);
};
const increaseExperience = () => {
  if (numberOfExperiences.value < 3) {
    addExperience(numberOfExperiences.value);
  }
};
const decreaseExperience = () => {
  if (numberOfExperiences.value > 1) {
    removeExperience(numberOfExperiences.value - 1);
  }
};
const openForm = () => (complementedTextOpened.value = false);
onMounted(() => {
  if (numberOfExperiences.value >= 1) {
    complementedTextOpened.value = true;
  } else {
    increaseExperience();
  }
});
</script>
